import React from 'react';
import Spline from '@splinetool/react-spline';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src="./logo.svg" alt="Logo" className="App-logo" />
      </header>
      <div className="Spline-container">
        <Spline
          scene="https://prod.spline.design/NQC1DEQtT2kKApnJ/scene.splinecode"
        />
      </div>
    </div>
  );
}

export default App;
